// tslint:disable
export const nl = {
  VerifyStatus: 'Status controleren',
  MarkAsDispensed: 'Markeren als afgeleverd',
  MarkAsSampled: 'Markeren als bemonsterd',
  UndoDispense: 'Afleveren ongedaan maken',
  UndoSample: 'Bemonstering ongedaan maken',
  MarkAsDestroyed: 'Markeren als vernietigd',

  Alert: 'Waarschuwing',
  ErrorCode: 'Foutcode',
  WarningFromNmvs: 'Waarschuwing van het nationale Medicatie Verificatie Systeem, voor EPC',
  Reason: 'Reden',
  ContactAcknowledge: 'Neem contact op met een groepslid om dit bericht te bevestigen.',
  Acknowledge: 'Bevestigen',

  CleanDateFormat: 'dd-mm-yyyy  h:MM:ss TT',
  ExpiryDateFormat: 'dd-mm-yyyy',
  ShortenedExpiryDateFormat: 'dd-mm-yyyy',

  ClearCompleted: 'Lijst wissen',
  ManualEntry: 'Handmatig invoeren',

  FileName: 'Bestandsnaam',
  Download: 'Download',
  ImvoPilotSetupInstructions: 'IMVO-proef configuratie-instructies',
  ZebraDevicesSetupInstructions: 'Zebra Devices configuratie-instructies',
  DataLogicGryphonGD4400: 'DataLogic Gryphon GD4400',
  DataLogicMagellan9800i: 'DataLogic Magellan 9800i',
  DataLogicMagellan3200VSI: 'DataLogic Magellan 3200 VSI',
  '232KeyConfiguration': '232Key configuratie-instellingen voor DataLogic Magellan 3200 VSI',

  ProductDetails: 'Productdetails',
  UserDetails: 'Gebruikersdetails',
  ProductIdentification: 'Productcode',
  SerialNumber: 'Serienummer',
  Expiry: 'Vervaldatum',
  LotNumber: 'Partijnummer',
  Status: 'Status',

  DeviceInfo: 'Apparaat info',
  UserProfile: 'Profiel',
  Users: 'Gebruikers',
  Settings: 'Instellingen',
  Documentation: 'Documentatie',
  Logout: 'Uitloggen',

  LoginErrorConnectivity: 'Bij de eerste keer inloggen moet u met het internet verbonden zijn.',
  SessionTimeout: 'Sessie verstreken',
  InvalidUsernamePassword: 'Gebruikersnaam/Wachtwoord ongeldig.',
  Unauthorized: 'Niet geautoriseerd',
  TenantDoesNotExist: 'Cliënt bestaat niet voor ID: ',
  Username: 'Gebruikersnaam',
  Password: 'Wachtwoord',
  UsernameRequirement: 'Gebruikersnaam moet tussen 5 en 50 tekens lang zijn',
  RetypePassword: 'Wachtwoord bevestigen',
  Login: 'Inloggen',
  FirstName: 'Voornaam',
  LastName: 'Achternaam',
  ForgotPassword: 'Wachtwoord vergeten',
  ConfirmPasswordReset: 'Bevestig wachtwoord reset',
  ConfirmPasswordResetMessage: 'Weet u zeker dat u een wachtwoordreset wil aanvragen voor {{username}}?',
  ResetPassword: 'Wachtwoord opnieuw instellen',
  PasswordResetSuccess: 'Er is een e-mail verzonden naar het e-mailadres. Volg de instructies in de e-mail om wachtwoord reset te voltooien.',
  PasswordResetError: 'Error: could not send the password reset email. Please try again in a few minutes.',
  PasswordResetOfflineError: 'Fout: u moet online zijn om uw wachtwoord opnieuw in te stellen.',
  ForgotPasswordContactAdmin: 'Neem contact op met uw Active Directory-beheerder.',
  Email: 'E-mailadres',
  OtherActions: 'Overige acties',
  UserInfoWarning: 'Waarschuwing: gebruikersnaam, voornaam en achternaam kunnen na het aanmaken van de gebruiker niet worden gewijzigd.',

  ScannedDateTime: 'Scam Datum/Tijd',
  NmvsResponseTime: 'NMVS-reactietijd',
  OptelResponseTime: 'Optel-reactietijd',
  TotalResponseTime: 'Totale reactietijd',
  Seconds: 'seconden',
  NotApplicable: 'n.v.t.',
  
  Scan: 'Scan',
  ScanOrTypeEpc: 'Scan of typ de elektronische productcode',
  EnterEpcManually: 'Try manually entering the electronic product code',
  EpcScannedAuditMessage: '{{username}} heeft de Epc: {{epc}} gescand, met bewerking: {{operation}}',
  AlertAcknowledgedAuditMessage: 'Melding bevestigd door {{username}} voor klantTransactieId: {{clientTransactionId}}',
  Pending: 'Lopend',
  NotFound: 'Niet gevonden',
  ProductCodeRequired: 'Er is een productcode vereist.',
  SerialNumberRequired: 'Er is een serienummer vereist.',
  BatchIdentifierRequired: 'Er is een partijnummer vereist.',
  ExpiryDateRequired: 'Er is een vervaldatum vereist.',
  UnprocessableEntity: 'Onverwerkbare entiteit',

  DeviceId: 'Apparaat-identifier',
  SystemInfo: 'Systeem informatie',
  Preferences: 'Voorkeursinstellingen',
  Credentials: 'Credentials',
  Country: 'Land',
  Language: 'Taal',
  LocationIdentifier: 'Locatie identifier',
  Certificate: 'Certificaat',
  CertificatePassword: 'Certificaat wachtwoord',
  Processing: 'Bezig met verwerken...',
  Save: 'Opslaan',
  CreateUser: 'Gebruiker aanmaken',
  Submit: 'Verzenden',
  ClientId: 'Cliënt-ID invoeren',
  FileNullError: 'Bij het uitlezen van het bestand is een fout opgetreden.',
  InvalidFileError: 'Fout: bestand moet eindigen op .pfx of .p12',
  OfflineSettingsMessage: 'Instellingen kunnen offline niet geactualiseerd worden.',

  RegisterDevice: 'Register Device',
  UnregisterDevice: 'Unregister Device',
  UnregisterDeviceWarning: 'If you click this button, it will unregister this device from your location until the device is registered again.',
  
  Details: 'Details',
  User: 'Gebruiker',
  Barcode: 'Barcode',
  Pin: 'PIN',
  RetypePin: 'PIN bevestigen',
  Role: 'Rol',
  ChangePIN: 'PIN wijzigen',
  ChangePassword: 'Wachtwoord wijzigen',
  PasswordMatchError: 'Wachtwoord stemt niet overeen.',

  NoAvailableOperations: 'Er zijn geen beschikbare handelingen voor dit artikel.',
  Verify: 'Controleren',
  TryVerifyAgain: 'Probeer opnieuw te verifiëren',
  Dispense: 'Afleveren',
  Sample: 'Monster',
  Destroy: 'Vernietigen',
  Reintroduce: 'Opnieuw introduceren',
  PleaseWait: 'Wacht even...',
  ProductCode: 'Productcode',
  AvailableOperations: 'Beschikbare handelingen',

  Cancel: 'Annuleren',
  AddUser: 'Gebruiker toevoegen',
  EditUser: 'Gebruiker bewerken',

  RoleTypeOptelAdmin: 'Optel Beheerder',
  RoleTypeOptelSupport: 'Optel Ondersteuning',
  RoleTypeTenantAdmin: 'Tenant Beheerder',
  RoleTypeOperator: 'Operator',
  RoleTypeViewer: 'Lezer',
  RoleTypeUnknown: 'Onbekend',

  Back: 'Terug',
  ActivateUser: 'Gebruiker activeren',
  DeactivateUser: 'Gebruiker deactiveren',
  DeleteUser: 'Gebruiker wissen',
  Delete: 'Wissen',
  DeleteUserWarning: 'If you click this button, this user will be deleted permanently and it\s username won\'t be available anymore.',
  DeleteUserConfirmation: 'Weet u zeker dat u wilt wissen {{username}} ?',
  Yes: 'Ja',
  No: 'Nee',
  ConfirmDeletion: 'Wissen bevestigen',
  Error: 'Fout',
  CommunicationError: 'Er is een communcatiefout opgetreden met de server. Klik om opnieuw te proberen.',
  SaveError: 'Er is een fout opgetreden tijdens het opslaan. Probeer het opnieuw op een later tijdstip.',
  ClickTryAgain: 'Klik hier om opnieuw te proberen.',
  ClickErrorIconTryAgain: 'Click the error icon to try again.',

  LandingPageSloganPart1: 'AAC - Traceability Pilot for the Canadian Primary Aluminium Industry',
  LandingPageSloganPart2: '',
  FMDAcronym: 'FMD',
  EuropeanAcronym: 'EU',
  TermsAndConditions: 'Algemene voorwaarden',
  AboutOptel: 'De OPTEL Group',
  AllRightsReserved : 'Alle rechten voorbehouden',
  OptelGroup: 'OPTELGroup',

  Online: 'Online',
  Offline: 'Offline',
  AwaitingConnection: 'Wacht op verbinding...',
  SimulateOffline: 'Offline simuleren',
  UndoOfflineWarning: 'Waarschuwing: bewerking ongedaan maken is uitgeschakeld in offline-modus.',

  NothingToShow: 'Niets om weer te geven.',
  LoadingCerta: 'Certa wordt geladen. Als dit langer dan 10 seconden duurt, vernieuw dan de pagina',

  OptelTermsOfUseTitle: 'Optel gebruiksvoorwaarden',
  NmvsTermsOfUseTitle: 'NMVS gebruiksvoorwaarden',
  NmvsTermsOfUseWarning: 'Let op: dient geaccepteerd te worden door de locatiebeheerder',
  Accept: 'Accepteren',
  Decline: 'Afwijzen',
  Ignore: 'Negeren',
  Dismiss: 'ontslaan',
  ClickHere: 'klik hier',
  
  MustAcceptTermsToLogin: 'U moet de gebruiksvoorwaarden aanvaarden om u aan te melden.',
  MustBeOnlineToAcceptTermsToLogin: 'U moet een online-verbinding hebben om de gebruiksvoorwaarden te aanvaarden en om u aan te melden.',

  Austria: 'Oostenrijk',
  Belgium: 'België',
  Bulgaria: 'Bulgarije',
  Croatia: 'Kroatië',
  Cyprus: 'Cyprus',
  CzechRepublic: 'Tsjechische Republiek',
  Denmark: 'Denemarken',
  Estonia: 'Estland',
  Finland: 'Finland',
  France: 'Frankrijk',
  Germany: 'Duitsland',
  Greece: 'Griekenland',
  Hungary: 'Hongarije',
  Iceland: 'IJsland',
  Ireland: 'Ierland',
  Italy: 'Italië',
  Latvia: 'Letland',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Litouwen',
  Luxembourg: 'Luxemburg',
  Malta: 'Malta',
  Netherlands: 'Nederland',
  Norway: 'Noorwegen',
  Poland: 'Polen',
  Portugal: 'Portugal',
  Romania: 'Roemenië',
  Slovakia: 'Slowakije',
  Slovenia: 'Slovenië',
  Spain: 'Spanje',
  Sweden: 'Zweden',
  Switzerland: 'Zwitserland',
  UnitedKingdom: 'Verenigd Koninkrijk',

  UnableToParseEpc: 'Niet in staat om elektronische productcode te ontleden.',
  UnderSizeError: 'Onvoldoende grootte fout',
  OverSizeError: 'Excessieve grootte fout',
  FixedSizeError: 'Vast grootte fout',
  NoSerializationData: 'Geen serialisatiegegevens.',
  InvalidCheckDigit: 'Ongeldig controlecijfer.',
  NoProductCodeForGtin: 'Er is geen productcode gevonden voor GTIN.',
  UrnFormatNotSupported: 'URN-Indeling wordt niet ondersteund',
  InvalidSymbologyIdentifier: 'Ongeldige symbologie-identificatie.',
  NoSymbologyIdentifier: 'Geen symbologie-identificatie',
  CouldNotFindTypeInfo: 'Geen TypeInfo gevonden.',
  NullTypeInfo: 'TypeInfo kan niet nul zijn.',
  DigitsOnly: 'Numeriek-AI bevat een niet-numeriek teken',
  CannotSerializeUnknownAi: 'Kan AI met onbekend type niet serialiseren.',
  CheckValueNotChar: 'Karakter moet numeriek zijn.',
  CheckValueTooBig: 'CheckValue kan niet groter zijn dan 9.',
  InvalidFormat: 'Ongeldige indeling.',
  CapsLockDetected: 'Scan is geblokkeerd omdat de CAPS LOCK-toets op ON staat.',
  CapsLockSolution: 'Druk op de CAPS LOCK-toets op uw toetsenbord en scan vervolgens de code opnieuw',
  ScanAttemptDetected: 'Er is een scan gedetecteerd maar deze kon niet worden geparseerd',
  ScanAttemptSolution: 'Zorg ervoor dat uw scanner correct is geconfigureerd zoals vereist door Optel om met de Certa-toepassing te werken',
  Active: 'Actief',
  FullName: 'Voor- en achternaam',
  OnlineAssistance: 'Certa online hulp',
  UnknownErrorOccurred: 'Er is een onbekende fout opgetreden in {{function}}.',
  SeparatorMissing: 'Ontbrekend GS-teken',
  SeparatorSolution: 'Configureer uw scanner opnieuw en converteer het GS-teken naar een spatie of  ^.',
  ScanCount: 'Scantelling',
  ProductName: 'Productnaam',
  ConfirmUnregisterDeviceMessage: 'Weet u zeker dat u uw apparaat wilt afmelden?',
  Confirm: 'Bevestigen'
};



// WEBPACK FOOTER //
// ./src/translations/translations.nl.ts